export const MIN_PASSWORD_LENGTH = 12;
export const MAX_PASSWORD_LENGTH = 64;

export const PASSWORD_NUMBER_REGEX = /[0-9]/;
export const PASSWORD_LETTER_REGEX = /[a-zA-Z]/;
export const PASSWORD_SYMBOL_REGEX = /[^a-zA-Z0-9]/;
